import React, { useEffect, useRef, useState } from "react"
//import { useDispatch, useSelector } from "react-redux"
import { TextField, IconButton, Typography, Box, Button } from "@mui/material"
import CalendarTodayIcon from "@mui/icons-material/CalendarToday"
import ClearIcon from "@mui/icons-material/Clear"
import { useDispatch, useSelector } from "react-redux"
import { setDateFilter, clearDateFilter } from "../../redux/actions/eventanilla"
// import { format } from "date-fns"
// import { Calendar } from "@material-ui/pickers"

export default function FilterDate() {
  const dispatch = useDispatch()
  const [openDatePicker, setOpenDatePicker] = useState(false)
  const [tempDate, setTempDate] = useState("")
  const datePickerRef = useRef(null)

  const selectedDate = useSelector(
    (state) => state?.eventanilla?.dateFilter || "",
  )

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        datePickerRef.current &&
        !datePickerRef.current.contains(event.target)
      ) {
        setOpenDatePicker(false)
        setTempDate("")
      }
    }

    if (openDatePicker) {
      document.addEventListener("mousedown", handleClickOutside)
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [openDatePicker])

  const formatDateForDisplay = (dateString) => {
    if (!dateString) return "Buscar por fecha"
    const date = new Date(dateString)
    return date.toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      timeZone: "UTC",
    })
  }

  const handleTempDateChange = (event) => {
    setTempDate(event.target.value)
  }

  const applyDateFilter = () => {
    if (tempDate) {
      dispatch(setDateFilter(tempDate))
    }
    setOpenDatePicker(false)
    setTempDate("")
  }

  const clearDate = () => {
    setTempDate("")
    dispatch(clearDateFilter())
    setOpenDatePicker(false)
  }

  const handleInputClick = () => {
    setTempDate(selectedDate)
    setOpenDatePicker(true)
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        position: "relative",
        marginLeft: "10px",
      }}
    >
      {/* <Typography
        variant="body2"
        sx={{
          color: "#028B7E",
          fontSize: "0.875rem",
          marginLeft: "10px",
          fontWeight: "bold",
          fontFamily: "Roboto",
        }}
      >
        Filtrar por fecha:
      </Typography> */}

      <Box sx={{ position: "relative" }}>
        {/* Input personalizado */}
        <Box
          onClick={handleInputClick}
          sx={{
            minWidth: 160,
            height: "33px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingLeft: "12px",
            paddingRight: "8px",
            border: "2px solid #028B7E",
            borderRadius: "7px",
            backgroundColor: "white",
            cursor: "pointer",
            "&:hover": {
              borderColor: "#00a78f",
            },
          }}
        >
          <Typography
            sx={{
              fontSize: "0.875rem",
              color: selectedDate ? "#000" : "#666",
            }}
          >
            {formatDateForDisplay(selectedDate)}
          </Typography>

          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <CalendarTodayIcon
              sx={{
                fontSize: "16px",
                color: "#028B7E",
              }}
            />
            {selectedDate && (
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation()
                  clearDate()
                }}
                title="Limpiar filtro de fecha"
                sx={{
                  padding: "2px",
                  marginLeft: "4px",
                  color: "#028B7E",
                  "&:hover": {
                    backgroundColor: "rgba(2, 139, 126, 0.1)",
                  },
                }}
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            )}
          </Box>
        </Box>

        {openDatePicker && (
          <Box
            ref={datePickerRef}
            sx={{
              position: "absolute",
              top: "45px",
              left: 0,
              zIndex: 1000,
              backgroundColor: "white",
              border: "2px solid #028B7E",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
              padding: "16px",
              minWidth: "200px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                marginBottom: "12px",
                paddingBottom: "8px",
                borderBottom: "1px solid #eee",
              }}
            >
              <CalendarTodayIcon
                sx={{
                  fontSize: "18px",
                  color: "#028B7E",
                  marginRight: "8px",
                }}
              />
              <Typography
                sx={{
                  fontSize: "0.9rem",
                  fontWeight: "bold",
                  color: "#028B7E",
                }}
              >
                Seleccionar fecha
              </Typography>
            </Box>

            <TextField
              type="date"
              size="small"
              fullWidth
              value={tempDate}
              onChange={handleTempDateChange}
              sx={{
                marginBottom: "16px",
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#ddd",
                  },
                  "&:hover fieldset": {
                    borderColor: "#028B7E",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#028B7E",
                  },
                },
              }}
            />

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Button
                variant="outlined"
                size="small"
                onClick={() => setOpenDatePicker(false)}
                sx={{
                  color: "#666",
                  borderColor: "#ddd",
                  "&:hover": {
                    borderColor: "#999",
                    backgroundColor: "#f5f5f5",
                  },
                }}
              >
                Cancelar
              </Button>

              <Box sx={{ display: "flex", gap: 1 }}>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={clearDate}
                  sx={{
                    color: "#d32f2f",
                    borderColor: "#d32f2f",
                    "&:hover": {
                      borderColor: "#b71c1c",
                      backgroundColor: "#ffebee",
                    },
                  }}
                >
                  Limpiar
                </Button>

                <Button
                  variant="contained"
                  size="small"
                  onClick={applyDateFilter}
                  disabled={!tempDate}
                  sx={{
                    backgroundColor: "#028B7E",
                    "&:hover": {
                      backgroundColor: "#026b61",
                    },
                    "&:disabled": {
                      backgroundColor: "#ccc",
                    },
                  }}
                >
                  Aplicar
                </Button>
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  )
}
